export * from './permission'
export const SAFE_STRING_PATTERN = '^[^./]+$'